export default __webpack_public_path__ + "static/media/empty-box.8689ab0c.svg";